define('areas/home/commands/logoutcommand',["require", "exports", "models/portal"], function (require, exports, Portal) {
    "use strict";
    var LogoutCommand = (function () {
        function LogoutCommand(router, usermanager, applications) {
            this._router = router;
            this._userManager = usermanager;
            this._applications = applications;
        }
        LogoutCommand.prototype.execute = function (unit) {
            // Publish logout broadcast to all tabs before signing out
            var shell = Portal.Context.shell;
            if (shell && typeof shell.publishLogoutBroadcast === 'function') {
                shell.publishLogoutBroadcast();
            }
            this._applications.clear();
            this._userManager.signOut();
        };
        return LogoutCommand;
    }());
    return LogoutCommand;
});

